export default __webpack_public_path__ + "static/media/working-forms-2x.69bb7d5d.png";